<template>
  <nav v-if="isMounted" class="nav primary" :class="[open ? 'is-open' : '', !isMobile && 'gridded-nav']" @mouseleave="hideNav">
	  <div class="col-3x1" v-if="!isMobile">
		  <div class="sub-nav-links">
		  <template v-for="(slice, idx) in slices">
			<template v-if="slice.slice_type === 'nav_item'">
				<div :key="'slice-' + idx"  class="one-fifth-groupings">
				<template v-for="(item, index) of slice.items">
					<div :key="'slice-' + index" class="sub-nav-link">
						<prismic-link @click.native="closeNav" :field="item.sub_nav_item_link">
					        <span>{{ item.sub_nav_item_label }}</span>
					    </prismic-link>
					</div>
				</template>
				</div>
			</template>
		  </template>
		  </div>
		  <div class="search">
			  <form @submit.prevent="submitSearchTerm">
			  	<input type="text" placeholder="search" v-model="searchTerm" />
			  	<button @click.prevent="submitSearchTerm" type="submit">→</button>
			  </form>
		  </div>
	  </div>
	  <div v-else>
		  <div class="grid-container c2">
			  	<div class="search">
			  		<form @submit.prevent="submitSearchTerm">
			  			<input type="text" placeholder="search" v-model="searchTerm" />
			  			<button @click.prevent="submitSearchTerm" type="submit">→</button>
			  		</form>
		  		</div>
			  <template v-for="(slice, index) in slices">
		      <template v-if="slice.slice_type === 'nav_item'">
			      <div :key="'slice-' + index" class="nav-group">
			      	<prismic-link :field="slice.primary.nav_item_link" class="nav-group-title">
					    	<span @click="closeNav">{{ slice.primary.nav_item_label }}</span>
			      	</prismic-link>
			        <ul>
				        <li v-for="(item, index) in slice.items" :key="'sub-item-' + index" class="text-condensed text-uppercase text-bold"  @click="closeNav">
					        <template v-if="item.sub_nav_item_link.link_type === 'Document'">
					        	<template v-if="item.sub_nav_item_section === null">
					        		<prismic-link :field="item.sub_nav_item_link">
					        			<span>{{ item.sub_nav_item_label }}</span>
					        		</prismic-link>
						    	</template>
						    	<template v-else>
						    		<router-link :to="'/' + item.sub_nav_item_link.uid + '/' + item.sub_nav_item_section">
						    			<span>{{ item.sub_nav_item_label }}</span>
						    		</router-link>
						    	</template>
					        </template>
							<template v-else>
								<prismic-link :field="item.sub_nav_item_link">
									<span>{{ item.sub_nav_item_label }}</span>
						      	</prismic-link>
							</template>
					    </li>
			        </ul>
			      </div>
		      </template>
		      <template v-else-if="slice.slice_type === 'nav_link'">
			      <div class="nav-group">
			      	<prismic-link :field="slice.primary.nav_item_link" class="nav-group-title">
					    	<span @click="closeNav">{{ slice.primary.nav_item_label }}</span>
			      	</prismic-link>
			      </div>
		      </template>
		    </template>
		  </div>
	  </div>
  </nav>
</template>


<script>

const removeClass = function (target, className) {
  target.classList.remove(className);
}

export default {
  name: 'Navigation',
  data () {
	  return {
		  slices: [],
		  isMounted: false,
		  searchTerm: ''
	  };
  },
  methods: {
	  itemDetails(item) {
		  console.log(item)
	  },
	  getContent () {
		  this.$prismic.client.getSingle('navigation')
		  	.then((document) => {
					console.log(document.data.nav);
			  	this.slices = document.data.nav;
		  	})
	  },

	  hideNav () {
		  this.$store.commit('openNav', false)
	  },

	  sanitizeTitle (title) {
      var slug = "";
      // Change to lower case
      var titleLower = title.toLowerCase();
      // Letter "e"
      slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, 'e');
      // Letter "a"
      slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, 'a');
      // Letter "o"
      slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, 'o');
      // Letter "u"
      slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, 'u');
      // Letter "d"
      slug = slug.replace(/đ/gi, 'd');
      // Trim the last whitespace
      slug = slug.replace(/\s*$/g, '');
      // Change whitespace to "-"
      slug = slug.replace(/\s+/g, '-');
      
      return slug;
    },
	  closeNav () {
    	this.$store.dispatch('toggleNav');
	},
	
	submitSearchTerm () {

		if (this.searchTerm.length === 0) return;
		if (this.$route.params.searchTerm !== this.searchTerm) {
			this.$router.push(`/search/${this.searchTerm}`);
			this.$ga.event('SearchTerm', this.searchTerm)
			this.searchTerm = '';
		}	
	}
  },
  created () {
	  this.getContent();
  },
  mounted () {
	// this.isMobile = window.innerWidth < 768 ? true : false;
	this.isMounted = true;

  },
  computed: {
	  open () {
		  return this.$store.state.navOpen
	  },
	  isMobile () { 
		  return this.$store.state.isMobile;
	  }
  },
  watch: {
	  open: function (open) {
		  console.log('open watcher')
	  }
  }
}
</script>

<style scoped>

	.gridded-nav {
		display: none;
		
	}

	.gridded-nav.is-open  {
		display: grid;
		height: auto !important;
		z-index: 1000;
	}

	.col-3x1 {
		display: grid;
		grid-template-columns: 4fr 1fr !important;
	}

	.sub-nav-links {
		width: 100%;
		display: flex;
		justify-content: space-between;
		padding: 1rem;
	}

	.one-fifth-groupings {
		width: 20%;
		border-right: 3px solid black;
		display: flex;
		align-items: space-between;
		flex-direction: column;
		/* flex: 1; */
	}

	.one-fifth-groupings:last-child {
		border-right: none;
	}

	.sub-nav-link {
		display: block;
		padding-left: 3rem;
		word-break: break-word;
		margin-bottom: 1rem;
		transition: opacity 300ms cubic-bezier(0.57, 0.06, 0.05, 0.95);
		position: relative;
		font-size: 1rem;
		display: flex;
		flex-direction: row;
		align-items: center;
		width: 100%;
	}

	.sub-nav-link a {
		width: 100%;
		height: 100%;
	}

	.one-fifth-groupings:first-child .sub-nav-link {
		padding-left: 2rem;
	}

	.one-fifth-groupings:first-child .sub-nav-link:before {
		left: 0;
	}

	

	.sub-nav-link:before {
		content: '';
		width: 16px;
		height: 8px;
		border: 1px solid black;
		background-color: transparent;
		border-radius: 8px;
		position: absolute;
		left: 1rem;
		line-height: 1;
		transition: all 300ms cubic-bezier(0.075, 0.82, 0.165, 1);
	}

	.sub-nav-link:hover:before, .sub-nav-link:focus:before {
		background-color: black !important;
	}

	.search {
		padding: 1rem;
		position: relative;
	}



	.search input {
		border: none;
		border-bottom: 1px solid black;
		padding: 0 0 0.5rem 0;
		color: black !important;
		
	}

	

	.search input:active {
		border-bottom: 1px solid black;
	}

	.search input:focus {
		border-bottom: 2px solid black;
	}

	.search input::placeholder {
		color: black;
		opacity: 0.7;
		text-transform: capitalize;
	}

	.search button {
		/* content: "→"; */
		display: block;
		font-size: 2rem;
		position: absolute;
		color: black;
		right: 1rem;
		top: 4px;
		cursor: pointer;
		transition: all 150ms cubic-bezier(0.075, 0.82, 0.165, 1);
		background-color: transparent;
		border: none;
		outline: none;
	}

	button:hover {
		opacity: 0.7;
	}

	@media screen and (max-width: 768px) {
		.gridded-nav {
			height: 25% !important;
		}

		.nav {
			z-index: 1000;
		}

		.search {
			padding: 1rem 2rem 0rem 2rem;
			background-color: white;
		}

		.search button {
			top: 0.5rem;
			right: 1.5rem;
		}

		.search + .nav-group {
			padding-top: 0 !important;
		}
	}
	
</style>
